import { render, staticRenderFns } from "./SelectionComponent.vue?vue&type=template&id=2acf74f9&scoped=true"
import script from "./SelectionComponent.vue?vue&type=script&lang=js"
export * from "./SelectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acf74f9",
  null
  
)

export default component.exports